module.exports = __webpack_public_path__ + "media/images/icons/job-green-54eda9f3078a9f41611b867e2ca8bdbb.svg";